import React, { ReactNode } from 'react';
import { useTransition, animated } from 'react-spring';

export interface AnimatedTransitionContainerProps {
  children: ReactNode,
  open: boolean,
  animationProps?: any,
  style?: React.CSSProperties
}

const AnimatedTransitionContainer:React.FC<AnimatedTransitionContainerProps> = ((userProps: AnimatedTransitionContainerProps) => {
  const {
    children,
    open,
    animationProps,
    style,
    ...otherProps
  } = userProps;
  const transitions = useTransition(open, null, animationProps);
  return (
    <>{transitions.map(({ item, key, props }) =>
      item && (
        <animated.div key={key} style={{ ...props, ...style }} {...otherProps}>
          {children}
        </animated.div>
      ))}
    </>);
});

AnimatedTransitionContainer.defaultProps = {
  animationProps: {},
  style: {}
};
/* Animation based on open/close. Initial use for Popups */
export default AnimatedTransitionContainer;